import { Box, Chip, LinearProgress, Typography } from '@mui/material'
import SimpleTable from 'common/components/SimpleTable'
import { getLocaleFromFullDate } from 'common/libs/fechas'

const EvaluacionesTable = ({ evaluaciones, loading, onClickEvent }) => {
  const fields = [
    { field: 'descripcion', title: 'Evaluación', flex: 2 },
    {
      field: 'n_evaluaciones',
      title: 'Estado',
      flex: 1,
      customGetter: (item) => {
        const porcentaje = Math.round(parseFloat(item.n_evaluaciones) || 0)
        const label =
          porcentaje === 100 ? 'Completada' : porcentaje > 0 ? 'En progreso' : 'Sin iniciar'
        const color = porcentaje === 100 ? 'success' : porcentaje > 0 ? 'primary' : 'default'
        return <Chip label={label} color={color} size="small" />
      },
    },
    {
      field: 'fecha_proceso',
      title: 'Proceso',
      flex: 1,
      customGetter: (item) =>
        item.fecha_proceso ? getLocaleFromFullDate(item.fecha_proceso, false) : '—',
    },
    {
      field: 'fecha_validez_est',
      title: 'Validez',
      flex: 1,
      customGetter: (item) =>
        item.fecha_validez_est ? getLocaleFromFullDate(item.fecha_validez_est, false) : '—',
    },
    {
      field: 'n_cerradas',
      title: 'Progreso',
      flex: 1,
      customGetter: (item) => {
        const porcentaje = Math.round(parseFloat(item.n_evaluaciones) || 0)
        const nTotal = item.n_total ?? null
        const nCerradas = Math.round(parseFloat(item.n_cerradas) || 0)
        return (
          <Box sx={{ width: '100%' }}>
            <LinearProgress variant="determinate" value={porcentaje} sx={{ mb: 0.5 }} />
            {nTotal !== null && (
              <Typography
                variant="caption"
                color="text.secondary"
                align="end"
                sx={{ width: '100%', display: 'block' }}
              >
                {nCerradas} de {nTotal}
              </Typography>
            )}
          </Box>
        )
      },
    },
  ]

  return (
    <SimpleTable
      loading={loading}
      dataSource={evaluaciones || []}
      onRowClick={(params) => onClickEvent(params.row.id)}
      fields={fields}
      stripped={true}
      emptyText="No hay evaluaciones disponibles."
    />
  )
}

export default EvaluacionesTable
